import React, { useMemo } from "react";
import { Button, Icon } from "semantic-ui-react";
import useQrCode from "../hooks/useQrCode";

const QrCodeGenerator = (props) => {
  const { qrValue, toggleVisibility, getQrCodeFromSiteCode } = useQrCode();
  const {
    state: { options, loading },
  } = props;

  useMemo(() => {
    getQrCodeFromSiteCode(options);
  }, [options]);

  return (
    <Button
      icon
      labelPosition="right"
      onClick={toggleVisibility}
      disabled={!qrValue.siteCode}
      loading={loading}
    >
      QR Code
      <Icon name="qrcode" />
    </Button>
  );
};
export default QrCodeGenerator;
